
<template>
  <div v-if="CheckSystemType('DiveBoss')" v-wechat-title="myTitle">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="topBackLevel" />
    <div class="inputRect">
      <van-field
        v-model="formData.lastName"
        required
        clearable
        label="姓"
        placeholder="例如zhang"
        :readonly="isHaveCerificate"
      />
      <van-field
        v-model="formData.firstName"
        required
        clearable
        label="名"
        placeholder="例如san feng"
        :readonly="isHaveCerificate"
      />
      <van-field
        v-model="formData.birthday"
        required
        clearable
        label="生日"
        placeholder="请输入生日"
        readonly
        @click="onSelectBirthday"
      />
      <van-field
        v-model="formData.email"
        clearable
        label="邮箱"
        placeholder="请输入电子邮箱"
      />
      <div class="buttonRect">
        <van-button type="primary" size="large" :disabled="buttonDisable" :loading="buttonLoading" :color="GetColorMain()" @click="onSubject">查询</van-button>
      </div>
    </div>

    <div v-if="isHaveCerificate" class="notice">您的信息已经确认，不能修改姓名、生日。如需修改请联系客服！</div>
    <div v-if="!isHaveCerificate" class="noticeAbout">
      证书查询说明:<br>
      1.请输入正确的姓名生日信息，我们将会前往潜水机构查询您的潜水资质;<br>
      2.如您拥有自由潜水员证书，必须填写电子邮箱;<br>
      3.姓名请填写英文(拼音)<br>例如:姓：zhang 名：san feng(务必注意每个中文字对应拼音用空格分开);<br>
      4.如无法检索出您的证书，请检查您在潜水机构的注册信息是否正确并与您输入的信息一致。
    </div>
    <dateSelect v-model="showBirthday" :default-date="baseDate" @onChange="onBirthdayChange" />
    <followWx v-model="showFollow" @finish="onFollowFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Toast, Dialog } from 'vant'
import { formatDate, MyNotify, checkUserLastName } from '@/utils/base'
import TopBar from '@/components/TopBar'
import dateSelect from '@/components/dateSelect'
import followWx from '@/components/followWx'
import { getUrlKey } from '@/utils/base'
import { CheckSystemType } from '@/utils/request'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    TopBar,
    dateSelect,
    followWx
  },
  data() {
    return {
      myTitle: '',
      topBackLevel: 1,
      commodityId: undefined,
      title: '证书查询',
      backurl: '/my/index',
      buttonLoading: false,
      showBirthday: false,
      baseDate: undefined,
      isHaveCerificate: true,
      isEmailCheck: false,
      showFollow: false,
      buttonDisable: true,
      autoSearch: false, // 自动查询
      formData: {
        lastName: '',
        firstName: '',
        birthday: '',
        email: ''
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    Toast.clear()
    next()
  },
  created() {
    this.commodityId = getUrlKey('cid')
    if (this.commodityId) {
      this.backurl = '/store/item/' + this.commodityId
      this.topBackLevel = 10000
    } else {
      this.topBackLevel = 10000
      this.backurl = '/my/myCerificate'
    }
    var name = getUrlKey('name')
    if (name) {
      this.onGetNamePy(name, (ln, fn) => {
        this.init(ln, fn)
      })
    } else {
      this.init()
    }

    this.myTitle = GetSysTitle()
  },
  methods: {
    CheckSystemType,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onGoBack() {
      window.history.length > this.topBackLevel
        ? this.$router.go(-this.topBackLevel)
        : this.$router.push(this.backurl)
    },
    onSelectBirthday() {
      if (this.isHaveCerificate) {
        return
      }
      this.showBirthday = true
    },
    onSubject() {
      if (!this.isHaveCerificate) {
        if (this.formData.lastName.length < 1) {
          MyNotify('error', '请输入英文（拼音）姓,例如zhang')
          return
        }
        if (this.formData.firstName.length < 1) {
          MyNotify('error', '请输入英文（拼音）名,例如san feng')
          return
        }
        if (this.formData.birthday.length < 1) {
          MyNotify('error', '请选择生日')
          return
        }
        let EmailStr = ''
        if (this.formData.email.length > 0) {
          EmailStr = '\n邮箱:' + this.formData.email
        }
        checkUserLastName(this.formData.firstName, () => {
          Dialog.confirm({
            title: '核对信息',
            message: '请核对您的\n英文姓:' + this.formData.lastName + '\n英文名:' + this.formData.firstName + '\n生日:' + this.formData.birthday + EmailStr + '\n是否正确,一旦提交无法修改'
          }).then(() => {
            this.onPostData()
          })
        })
      } else {
        this.onPostData()
      }
    },
    init(ln, fn) {
      request({
        url: '/user/getUserNameBirthday',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        var name = getUrlKey('name')
        var birthday = getUrlKey('birthday')
        var email = getUrlKey('mail')
        this.isHaveCerificate = response.data.isHaveCerificate
        if (this.isHaveCerificate) {
          if (email === response.data.email) {
            this.onGoBack()
            return
          }
        }
        this.formData.lastName = response.data.lastName ? response.data.lastName : ''
        this.formData.firstName = response.data.firstName ? response.data.firstName : ''
        this.formData.email = response.data.email ? response.data.email : ''
        this.isEmailCheck = response.data.isEmailCheck
        if (response.data.birthday) {
          this.baseDate = response.data.birthday
          this.formData.birthday = formatDate(response.data.birthday, 'yyyy/MM/dd')
        }

        if (!this.isHaveCerificate) {
          if (!response.data.lastName && name) {
            this.formData.lastName = ln
            this.formData.firstName = fn
          }
          if (!response.data.birthday && birthday) {
            this.baseDate = birthday
            this.formData.birthday = formatDate(birthday, 'yyyy/MM/dd')
          }
        }
        if (!response.data.email && email) {
          this.formData.email = email
        }
        // 是否自动查询
        if (!this.isHaveCerificate && name && birthday && email) {
          this.autoSearch = true
        }
        setTimeout(() => {
          this.showFollow = true
        }, 10)
      })
    },
    onGetNamePy(name, callback) {
      request({
        url: '/User/getNamePySpace',
        method: 'post',
        params: { name: name }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (callback) {
          callback(response.data.lastName, response.data.firstName)
        }
      })
    },
    onFollowFinish() {
      this.buttonDisable = false
      if (this.autoSearch) {
        this.autoSearch = false
        this.onPostData()
      }
    },
    onBirthdayChange(date) {
      this.formData.birthday = date
    },
    onPostData() {
      this.buttonLoading = true
      request({
        url: '/user/updateUserNameBirthday',
        method: 'post',
        data: this.formData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (response.data) {
          Dialog.alert({
            title: '提交失败',
            message: response.data
          }).then(() => {
          })
          return
        }
        this.onWait()
      })
    },
    onWait() {
      this.waitTime = 180
      this.toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '目前核实身份人数较多，核实成功后将以公众号消息通知您参与活动,预计' + this.waitTime + '秒!'
      })
      this.waitTimer = setInterval(() => {
        this.waitTime--
        if (this.waitTime > 0 && this.waitTime < 160) {
          this.toastLoading.message = '目前核实身份人数较多，您可以关闭页面，核实成功后，将以公众号通知形式邀请您参与活动[' + this.waitTime + '秒]!'
          if (this.waitTime % 10 === 0) {
            this.onCheckFinish()
          }
        } else if (this.waitTime > 0) {
          this.toastLoading.message = '目前核实身份人数较多，核实成功后将以公众号消息通知您参与活动,预计' + this.waitTime + '秒!'
          if (this.waitTime % 10 === 0) {
            this.onCheckFinish()
          }
        } else {
          clearInterval(this.waitTimer)
          Toast.clear()
          Dialog.confirm({
            title: '未能完成检查',
            message: '非常抱歉，我们尚未能完成对您资质证书的检查，稍后查询完成我们将会给你发送推送通知，您是否现在继续等待?'
          }).then(() => {
            this.onWait()
          })
        }
      }, 1000)
    },
    onCheckFinish() {
      request({
        url: '/user/getUserHaveCertificate',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        if (response.data.have) {
          clearInterval(this.waitTimer)
          Toast.clear()
          Dialog.alert({
            title: '查询成功',
            message: '恭喜您，已经查询到了您的潜水员资质证书！'
          }).then(() => {

          })
          this.onGoBack()
          console.log('onGoBack')
        } else if (response.data.finish) {
          clearInterval(this.waitTimer)
          Toast.clear()
          Dialog.alert({
            title: '未查询到您的潜水资质',
            message: '未能查询到您拥有潜水员资质，请检查您输入的英文(拼音)姓名、出生日期、邮箱是否正确。'
          }).then(() => {

          })
        }
      })
    }
  }
}
</script>
<style scoped>
.notice{
  color: #999;
  text-align: center;
  font-size: 0.7em;
  margin-top: 0.3em;
}
.noticeAbout{
  color: #999;
  text-align: left;
  font-size: 0.9em;
  margin-top: 1em;
  padding: 0 1.5em;
  line-height: 1.5em;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
</style>
